import { Alert } from "@mui/material";
import { ModelSavingData } from "src/hooks/use-model-saving-data";

type DisplayErrorsProps = {
  savingData: ModelSavingData<any>
}

export default function DisplayErrors({ savingData }: DisplayErrorsProps) {
  if (savingData.errors && savingData.errors.length) {
    return <Alert severity="error" sx={{ marginBottom: 2 }} >
      {savingData.errors.map((err, index) => <div key={index}>{err.message}</div>)}
    </Alert>
  }

  return null;
}